import { render, staticRenderFns } from "./LieferscheineLayout.vue?vue&type=template&id=1a826022"
import script from "./LieferscheineLayout.vue?vue&type=script&lang=js"
export * from "./LieferscheineLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports